export { default } from './EmbedSocialMedia'
